export const API_CONFIG = {
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://auth.prepstripe.com/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
};

export const APP_CONFIG = {
  name: import.meta.env.VITE_APP_NAME || 'PrepStripe SSO',
  version: import.meta.env.VITE_APP_VERSION || '1.0.0',
};

export const AUTH_CONFIG = {
  tokenKey: 'access_token',
  refreshTokenKey: 'refresh_token',
  userKey: 'user',
  tokenExpiryKey: 'token_expires_at',
};

export const ROUTES = {
  // Auth
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  VERIFY_EMAIL: '/verify-email',
  MFA: '/mfa',
  
  // Dashboard
  DASHBOARD: '/',
  
  // Users
  USERS: '/users',
  USER_DETAIL: '/users/:id',
  USER_CREATE: '/users/create',
  USER_EDIT: '/users/:id/edit',
  
  // OAuth
  OAUTH_CLIENTS: '/oauth/clients',
  OAUTH_CLIENT_DETAIL: '/oauth/clients/:id',
  OAUTH_TOKENS: '/oauth/tokens',
  
  // RBAC
  ROLES: '/rbac/roles',
  PERMISSIONS: '/rbac/permissions',
  
  // Tenants
  TENANTS: '/tenants',
  TENANT_DETAIL: '/tenants/:id',
  
  // Access Policies
  POLICIES: '/policies',
  POLICY_DETAIL: '/policies/:id',
  
  // Analytics
  ANALYTICS: '/analytics',
  
  // Settings
  SETTINGS: '/settings',
  PROFILE: '/profile',
} as const;
